import { addSpaceBetweenCamelCase, AgxRow } from '@urbanx/agx-ui-components'
import placeHolderImage from 'assets/images/placeholder-property.png'
import { useSelectedContract } from 'hooks'
import { AgxTypography } from '@urbanx/agx.ui-components2'
import './CampaignImage.scss'

interface ContractImageProps {
  imageUrl?: string
}

const ContractImage = ({ imageUrl }: ContractImageProps) => {
  const { contract } = useSelectedContract()

  return (
    <AgxRow extraClasses="propertyImageContainer">
      {contract?.contractStage && (
        <div className="campaignImage-imageBadgeContainer">
          <AgxTypography
            id={'imgBadgeTxt'}
            type={'tag'}
            size={'medium'}
            color="var(--text-brand-main)"
            flexShrink={0}
          >
            {addSpaceBetweenCamelCase(contract.contractStage)}
          </AgxTypography>
        </div>
      )}
      <img alt="" className="propertyImage" src={imageUrl ?? placeHolderImage} />
    </AgxRow>
  )
}

export default ContractImage
